export function useNewImageSubdomain() {
  function addNewImageSubdomain(url: string | undefined) {
    if (!url) return ''

    return url.replace(/images(1|2|3)\.bonhams\.com/, 'img$1.bonhams.com')
  }

  return { addNewImageSubdomain }
}
